<button
  type="button"
  class="btn btn-outline-danger dashboard-taxes-card-delete-button border-0"
  (click)="buttonClick.emit($event)"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    class="button-icon-svg"
    stroke="currentColor"
  >
    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
  </svg>
</button>
